module.exports = __webpack_public_path__ + "9c0831b2a3d9e815761ec6c67110d318.jpg";